import styled from '@emotion/styled';
import {
  Icon,
  Tooltip,
  Typography,
  useGlimmerTheme,
} from '@innovamat/glimmer-components';

const StudentName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InfoTooltip = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NameTypography = styled(Typography.Body2)<{ isDisabled: boolean }>`
  color: ${({ isDisabled, theme }) =>
    isDisabled
      ? theme.tokens.color.alias.cm.text['text-disabled'].value
      : theme.tokens.color.alias.cm.text['text'].value};
`;

type Props = {
  value: string;
  isDisabled?: boolean;
  hasTooltip?: boolean;
  tooltipText?: string;
};

function StudentNameCell({
  value,
  isDisabled = false,
  hasTooltip = false,
  tooltipText,
}: Props): JSX.Element {
  const theme = useGlimmerTheme();

  return (
    <StudentName>
      <NameTypography isDisabled={isDisabled}>{value}</NameTypography>
      {hasTooltip && (
        <InfoTooltip>
          <Tooltip content={tooltipText ?? ''} placement="top">
            <Icon
              icon="InfoIcon"
              size="S"
              iconColor="white"
              hasStateLayer
              bgColor={theme.tokens.color.alias.cm.icon['icon-info'].value}
            />
          </Tooltip>
        </InfoTooltip>
      )}
    </StudentName>
  );
}

export { StudentNameCell };
